import { Container } from "reactstrap";
import { ToastContainer } from "../../../components/Common";
import MyDevicesPage from "./page";

const OwnerDevicesPageWrapper = () => {
  //meta title
  document.title = "My Machines";

  return (
    <>
        <div className="page-content">
            <Container fluid>
                <MyDevicesPage />
            </Container>
        </div>

        <ToastContainer />
    </>
  );
};

export default OwnerDevicesPageWrapper;
